(function($) {
    'use strict';
    var utils;
    var $t11Inputs;
    var $d1Inputs;
    
    function filter(e) {
        var arr = [];
        var t11q = "";
        var searchOn = false;

        $t11Inputs.each(function() {
            if (this.checked) {
                if (t11q !== "") t11q += ",";
                t11q += this.value;
            }
        });
        if (t11q !== "") {
            arr.push("t11=" + t11q);
            searchOn = true;
        }
        if ($d1Inputs[0].checked) {
            arr.push("range2=" + $d1Inputs.val());
            searchOn = true;
        }
        if(utils.getUrlParameter('q') && utils.getUrlParameter('q').length > 0){
            arr.push("q=" + utils.getUrlParameter('q'));
            searchOn = true;
        }
        if(searchOn){
            arr.push("search=true");
        }

        if (utils.getUrlParameter('categoryId') != undefined) {
            arr.push('categoryId='+utils.getUrlParameter('categoryId'));
        }

        window.location.href = $('.shop-filters').attr('data-url') + '?' + arr.join("&");
    }
    
    function openSidebar(e) {
        var id = this.getAttribute("data-id");
        $("#" + id).addClass("open");
    }
    function closeSidebar(e) {
        var id = this.getAttribute("data-id");
        $("#" + id).removeClass("open");
    }

	var init = function() {
		utils = Fw.component.models().utils;
		$t11Inputs = $(".sidebar__filter-t11 input");
		$d1Inputs = $(".sidebar__filter-d1 input");
    
		$t11Inputs.on("change", filter);
		$d1Inputs.on("change", filter);

		$('.sidebar__trigger').click(function() {
			$(this).parent().toggleClass('sidebar__item_active');
		});

		$(".mobile-sidebar-open-btn").click(openSidebar);
		$(".mobile-sidebar-close-btn").click(closeSidebar);
	};
	
	$(window).ready(function () {
		init();
	});
    
})(jQuery);